import { IconButton } from '@mui/material';
import { LightMode, DarkMode } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '../../app/hooks';

import { Themes, themeChanged } from '../../app/appSlice';

const ThemeSwitcherButton = () => {
  const dispatch = useAppDispatch();
  const { theme } = useAppSelector((state) => state.app);

  const toggleTheme = () => {
    if (theme === Themes.Dark) {
      dispatch(themeChanged(Themes.Light));
    } else {
      dispatch(themeChanged(Themes.Dark));
    }
  };

  if (theme === Themes.Dark) {
    return (
      <IconButton onClick={toggleTheme} color='inherit'>
        <DarkMode />
      </IconButton>
    );
  } else {
    return (
      <IconButton onClick={toggleTheme} color='inherit'>
        <LightMode />
      </IconButton>
    );
  }
};

export default ThemeSwitcherButton;
